export * from "./properties/app/appProperties";
